/* PILLAR cart drawer enhancements — "You may also like" recommendations (deduped,
   anchored at the bottom, larger cards) + three-button layout
   (Proceed to Checkout / View Bag / Continue Shopping). Re-runs on drawer render. */
(function () {
  if (window.__pdInit) return;
  window.__pdInit = true;

  var INK = '#343131';
  var css = [
    '.pd-recs{border-top:1px solid #ece8e1;margin:18px 0 4px;padding:16px 0 2px;}',
    '.pd-recs__title{font-size:.74rem;letter-spacing:.16em;text-transform:uppercase;font-weight:700;color:' + INK + ';margin-bottom:13px;}',
    '.pd-recs__row{display:flex;gap:13px;overflow-x:auto;padding-bottom:6px;-webkit-overflow-scrolling:touch;}',
    '.pd-rec{flex:0 0 150px;text-decoration:none;color:' + INK + ';}',
    '.pd-rec__img{width:150px;height:188px;object-fit:cover;background:#f4f3ef;display:block;}',
    '.pd-rec__t{font-size:.82rem;line-height:1.25;margin-top:9px;}',
    '.pd-rec__p{font-size:.82rem;color:#5b574f;margin-top:3px;}',
    '@media(max-width:620px){.pd-rec{flex:0 0 128px;}.pd-rec__img{width:128px;height:160px;}.pd-recs{margin:14px 0 2px;}.cart-drawer__footer{padding-bottom:78px !important;}}',
    '.pd-btns{display:flex;gap:10px;margin-top:10px;}',
    '.pd-btn{flex:1;text-align:center;padding:13px 8px;font-size:.72rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;border:1.5px solid ' + INK + ' !important;color:' + INK + ' !important;background:#fff !important;cursor:pointer;transition:background .18s,color .18s;}',
    '.pd-btn:hover{background:' + INK + ' !important;color:#fff !important;}'
  ].join('');
  var st = document.createElement('style');
  st.id = 'pd-css';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\.00$/, ''); }

  function addButtons(drawer) {
    var cb = drawer.querySelector('.cart-drawer__footer .checkout-buttons');
    if (!cb || cb.querySelector('.pd-btns')) return;
    var checkout = cb.querySelector('a');
    if (checkout && /check\s?out/i.test(checkout.textContent)) checkout.textContent = 'Proceed to Checkout';
    var row = document.createElement('div');
    row.className = 'pd-btns';
    var bag = document.createElement('a');
    bag.className = 'pd-btn'; bag.href = '/cart'; bag.textContent = 'View Bag';
    var cont = document.createElement('a');
    cont.className = 'pd-btn'; cont.href = '#'; cont.textContent = 'Continue Shopping';
    cont.addEventListener('click', function (e) {
      e.preventDefault();
      var modal = document.querySelector('.cart-drawer-modal');
      var x = modal && modal.querySelector('.cc-popup-close');
      if (x) x.click();
      else if (modal) { modal.classList.remove('cc-popup--visible'); modal.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('cc-popup-open'); }
    });
    row.appendChild(bag); row.appendChild(cont);
    cb.appendChild(row);
  }

  var recsBusy = false, recsCache = null;
  function addRecs(drawer) {
    var area = drawer.querySelector('.cart-drawer__content-upper');
    if (!area || area.querySelector('.pd-recs') || recsBusy) return;
    if (recsCache) { inject(recsCache); return; }
    recsBusy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items || !cart.items.length) { recsBusy = false; return; }
      var pid = cart.items[0].product_id;
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=12&intent=related', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          recsBusy = false;
          var inCart = {}, seen = {};
          cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
          var recs = (res.products || []).filter(function (p) {
            if (inCart[p.id] || p.available === false) return false;
            var key = (p.title || '').toLowerCase().trim();
            if (seen[key]) return false;
            seen[key] = 1;
            return true;
          }).slice(0, 8);
          if (!recs.length) return;
          recsCache = recs;
          inject(recs);
        })
        .catch(function () { recsBusy = false; });
    }).catch(function () { recsBusy = false; });
  }

  function inject(recs) {
    var area = document.querySelector('.cart-drawer__content-upper');
    if (!area || area.querySelector('.pd-recs')) return;
    var h = '<div class="pd-recs__title">You may also like</div><div class="pd-recs__row">';
    recs.forEach(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img) { if (img.indexOf('//') === 0) img = 'https:' + img; img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=320'; }
      h += '<a class="pd-rec" href="' + p.url + '"><img class="pd-rec__img" loading="lazy" src="' + img + '" alt=""><div class="pd-rec__t">' + p.title + '</div><div class="pd-rec__p">' + money(p.price) + '</div></a>';
    });
    h += '</div>';
    var box = document.createElement('div');
    box.className = 'pd-recs';
    box.innerHTML = h;
    area.appendChild(box);
  }

  function enhance() {
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer) return;
    addButtons(drawer);
    addRecs(drawer);
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(enhance);
  ['cart:updated', 'cart:refresh', 'cart:build', 'theme:cart-change', 'ajaxProduct:added'].forEach(function (e) {
    document.addEventListener(e, function () { setTimeout(enhance, 220); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href$="/cart"],.cart-link,.quickbuy-toggle')) setTimeout(enhance, 700);
  });
  var n = 0, iv = setInterval(function () { n++; enhance(); if (n > 20) clearInterval(iv); }, 1000);
})();
